    document.addEventListener("DOMContentLoaded", () => {
      // 1. Anti-Cheat and State Management
      const playedTimestamp = localStorage.getItem("fntroo_play_timestamp");
      const activeDiscount = localStorage.getItem("fntroo_discount");
      
      const oneDayInMs = 24 * 60 * 60 * 1000;
      const now = Date.now();
      
      const gameActiveView = document.getElementById("game-active-view");
      const gameControlsView = document.getElementById("game-controls-view");
      const gameLockedView = document.getElementById("game-locked-view");
      const lockedCodeText = document.getElementById("locked-code-text");
      
      // If played in the last 24 hours, block replaying
      if (playedTimestamp && (now - parseInt(playedTimestamp) < oneDayInMs) && activeDiscount) {
        const discountObj = JSON.parse(activeDiscount);
        gameActiveView.style.display = "none";
        gameControlsView.style.display = "none";
        gameLockedView.style.display = "block";
        lockedCodeText.textContent = discountObj.code;
        const lockedPercent = document.getElementById("locked-code-percent");
        if (lockedPercent) lockedPercent.textContent = `${discountObj.percent}% OFF — ADDITIONAL GAME REWARD`;
        return;
      }

      // 2. Physics & Engine Setup
      const canvas = document.getElementById("plinko-canvas");
      const ctx = canvas.getContext("2d");
      const launchBtn = document.getElementById("launch-drop-btn");
      const slots = document.querySelectorAll(".plinko-slot");
      
      // Load monogram logo for the coin
      // Path comes from page-play.liquid (window.FNTROO_MONOGRAM_URL) since this
      // is a plain .js asset - Liquid's asset_url filter can't run in here, and
      // "assets/funtroo_monogram.svg" only worked on the old static site where
      // the page itself lived at the site root.
      const monogramImg = new Image();
      monogramImg.src = window.FNTROO_MONOGRAM_URL || "";
      
      // Pegboard nodes config
      const pegs = [];
      const startY = 80;
      const rowSpacing = 44;
      const pegSpacing = 42;
      const numRows = 8;
      
      for (let row = 0; row < numRows; row++) {
        const numPegs = row + 3;
        const rowWidth = (numPegs - 1) * pegSpacing;
        const startX = (canvas.width - rowWidth) / 2;
        
        for (let col = 0; col < numPegs; col++) {
          pegs.push({
            x: startX + col * pegSpacing,
            y: startY + row * rowSpacing,
            radius: 3.5,
            glow: 0
          });
        }
      }
      
      // Coin object
      const coin = {
        x: canvas.width / 2,
        y: 35,
        vx: 0,
        vy: 0,
        radius: 14,
        gravity: 0.22,
        bounce: 0.38,
        friction: 0.985,
        state: "idle", // "idle", "dropping", "landed"
        trail: [],
        pulseTimer: 0
      };
      
      // Predetermined slot variables
      let targetSlot = 0;
      let targetPercent = 10;
      let targetCode = "FNTROO10";
      
      // Determine win on button click
      function rollProbability() {
        const roll = Math.floor(Math.random() * 100) + 1; // 1 to 100
        
        // 50% discount (1% chance)
        if (roll === 1) {
          targetSlot = 3; // Center slot
          targetPercent = 50;
          targetCode = "FNTROO50";
        }
        // 30% discount (14% chance: rolls 2-15)
        else if (roll > 1 && roll <= 15) {
          targetSlot = Math.random() < 0.5 ? 2 : 4;
          targetPercent = 30;
          targetCode = "FNTROO30";
        }
        // 20% discount (25% chance: rolls 16-40)
        else if (roll > 15 && roll <= 40) {
          targetSlot = Math.random() < 0.5 ? 1 : 5;
          targetPercent = 20;
          targetCode = "FNTROO20";
        }
        // 10% discount (60% chance: rolls 41-100)
        else {
          targetSlot = Math.random() < 0.5 ? 0 : 6;
          targetPercent = 10;
          targetCode = "FNTROO10";
        }
      }
      
      // 3. Physics Simulation Loop
      function updatePhysics() {
        if (coin.state !== "dropping") return;
        
        // Apply gravity and update position
        coin.vy += coin.gravity;
        coin.x += coin.vx;
        coin.y += coin.vy;
        
        // Apply friction
        coin.vx *= coin.friction;
        coin.vy *= coin.friction;
        
        // Append coordinates to motion trail
        coin.trail.push({ x: coin.x, y: coin.y });
        if (coin.trail.length > 18) coin.trail.shift();
        
        // Wall boundaries
        if (coin.x < coin.radius + 15) {
          coin.x = coin.radius + 15;
          coin.vx *= -coin.bounce;
        }
        if (coin.x > canvas.width - coin.radius - 15) {
          coin.x = canvas.width - coin.radius - 15;
          coin.vx *= -coin.bounce;
        }
        
        // Pre-calculated target steering force (begins at bottom half)
        if (coin.y > 220) {
          const targetX = (targetSlot + 0.5) * (canvas.width / 7);
          const diffX = targetX - coin.x;
          // Apply a gentle nudge vector
          coin.vx += diffX * 0.0055;
        }
        
        // Peg collisions
        pegs.forEach(peg => {
          const dx = coin.x - peg.x;
          const dy = coin.y - peg.y;
          const dist = Math.sqrt(dx * dx + dy * dy);
          const minDist = coin.radius + peg.radius;
          
          if (dist < minDist) {
            // Push out to resolve intersection
            const nx = dx / dist;
            const ny = dy / dist;
            const overlap = minDist - dist;
            coin.x += nx * overlap;
            coin.y += ny * overlap;
            
            // Calculate relative velocity
            const vn = coin.vx * nx + coin.vy * ny;
            if (vn < 0) {
              const impulse = -(1 + coin.bounce) * vn;
              coin.vx += nx * impulse;
              coin.vy += ny * impulse;
              
              // Unpredictable scatter offset
              coin.vx += (Math.random() - 0.5) * 1.6;
              
              // Trigger peg glow state
              peg.glow = 1.0;
            }
          }
        });
        
        // Check landing condition
        if (coin.y > canvas.height - coin.radius) {
          coin.state = "landed";
          coin.vy = 0;
          coin.vx = 0;
          
          // Calculate landing index
          const finalSlot = Math.min(6, Math.max(0, Math.floor(coin.x / (canvas.width / 7))));
          highlightWinningSlot(finalSlot);
          triggerWinPopup();
        }
      }
      
      // 4. Drawing Render Loop
      function draw() {
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        
        // Draw pegboard boundaries (editorial frames)
        ctx.strokeStyle = "#1f1f1f";
        ctx.lineWidth = 1.5;
        ctx.strokeRect(15, 10, canvas.width - 30, canvas.height - 10);
        
        // Render motion trail ribbon
        if (coin.state === "dropping" && coin.trail.length > 1) {
          ctx.beginPath();
          ctx.moveTo(coin.trail[0].x, coin.trail[0].y);
          for (let i = 1; i < coin.trail.length; i++) {
            ctx.lineTo(coin.trail[i].x, coin.trail[i].y);
          }
          ctx.strokeStyle = "rgba(168, 85, 247, 0.4)"; // Purple trail
          ctx.lineWidth = coin.radius * 1.1;
          ctx.lineCap = "round";
          ctx.lineJoin = "round";
          ctx.stroke();
        }
        
        // Render pegs with dynamic fade-out glow
        pegs.forEach(peg => {
          ctx.beginPath();
          ctx.arc(peg.x, peg.y, peg.radius, 0, Math.PI * 2);
          
          if (peg.glow > 0) {
            ctx.fillStyle = `rgba(0, 255, 170, ${peg.glow})`;
            ctx.shadowBlur = 12 * peg.glow;
            ctx.shadowColor = "#00ffaa";
            peg.glow -= 0.04; // Fade peg glow
          } else {
            ctx.fillStyle = "#333333";
            ctx.shadowBlur = 0;
          }
          ctx.fill();
          ctx.shadowBlur = 0; // Reset shadow
        });
        
        // Render Coin Token
        ctx.save();
        
        // Coin floating animations on idle
        if (coin.state === "idle") {
          coin.pulseTimer += 0.05;
          coin.y = 35 + Math.sin(coin.pulseTimer) * 5;
          
          // Glow pulse under the coin
          ctx.shadowBlur = 15 + Math.sin(coin.pulseTimer) * 5;
          ctx.shadowColor = "#00ffaa";
        } else if (coin.state === "dropping") {
          ctx.shadowBlur = 10;
          ctx.shadowColor = "#a855f7"; // Purple glow during drop
        }
        
        // Draw coin circle outline
        ctx.beginPath();
        ctx.arc(coin.x, coin.y, coin.radius, 0, Math.PI * 2);
        ctx.fillStyle = "#ffffff";
        ctx.fill();
        ctx.strokeStyle = coin.state === "dropping" ? "#a855f7" : "#00ffaa";
        ctx.lineWidth = 2.5;
        ctx.stroke();
        
        // Clip and draw Funtroo interlocking monogram logo
        ctx.beginPath();
        ctx.arc(coin.x, coin.y, coin.radius - 1, 0, Math.PI * 2);
        ctx.clip();
        
        // Render original brand monogram SVG inside coin
        // naturalWidth check matters: a failed image still reports complete=true,
        // and drawImage() throws on a broken image - which would kill this whole
        // requestAnimationFrame loop permanently on the very next frame.
        if (monogramImg.complete && monogramImg.naturalWidth > 0) {
          ctx.drawImage(monogramImg, coin.x - coin.radius + 3, coin.y - coin.radius + 3, (coin.radius - 3) * 2, (coin.radius - 3) * 2);
        } else {
          // Monospace fallback if image fails to render
          ctx.fillStyle = "#000000";
          ctx.font = "bold 14px monospace";
          ctx.textAlign = "center";
          ctx.textBaseline = "middle";
          ctx.fillText("FF", coin.x, coin.y);
        }
        
        ctx.restore();
      }
      
      function gameLoop() {
        updatePhysics();
        draw();
        requestAnimationFrame(gameLoop);
      }
      
      // Start loop
      gameLoop();
      
      // 5. Game Interactions
      launchBtn.addEventListener("click", () => {
        if (coin.state !== "idle") return;
        
        launchBtn.disabled = true;
        
        // Set pre-determined result
        rollProbability();
        
        // Transition state to drop
        coin.state = "dropping";
        coin.vx = (Math.random() - 0.5) * 3; // Random initial speed
        coin.vy = 0;
        coin.trail = [];
      });
      
      function highlightWinningSlot(slotIndex) {
        slots.forEach((slot, idx) => {
          if (idx === slotIndex) {
            slot.classList.add("active");
          } else {
            slot.classList.remove("active");
          }
        });
      }
      
      function triggerWinPopup() {
        // Save state to localstorage immediately (Anti-Cheat lock)
        localStorage.setItem("fntroo_play_timestamp", now.toString());
        
        // Show winner popup with a slight delay
        setTimeout(() => {
          const winOverlay = document.getElementById("win-modal-overlay");
          const winHeadline = document.getElementById("win-headline");
          
          winHeadline.textContent = `YOU WON A ${targetPercent}% DISCOUNT!`;
          winOverlay.classList.add("show");
        }, 800);
      }
      
      // Handle Lead Capture Form Submission
      const regForm = document.getElementById("game-register-form");
      if (regForm) {
        regForm.addEventListener("submit", (e) => {
          e.preventDefault();
          
          const nameVal = document.getElementById("reg-name").value.trim();
          const emailVal = document.getElementById("reg-email").value.trim();
          const phoneVal = document.getElementById("reg-phone").value.trim();
          
          const submitBtn = regForm.querySelector('button[type="submit"]');
          if (submitBtn) {
            submitBtn.textContent = "GENERATING CODE...";
            submitBtn.disabled = true;
          }

          function completeLead(finalCode) {
            // 1. Save customer details to localStorage for checkout pre-filling
            localStorage.setItem("fntroo_customer", JSON.stringify({
              name: nameVal,
              email: emailVal,
              phone: phoneVal
            }));
            if (typeof window.updateHeaderAccountGreeting === "function") {
              window.updateHeaderAccountGreeting();
            }
            
            // 2. Save discount code details to localStorage for cart calculations
            localStorage.setItem("fntroo_discount", JSON.stringify({
              code: finalCode,
              percent: targetPercent
            }));
            
            // 3. Hydrate local cart footer
            if (typeof renderCartDrawer === "function") {
              renderCartDrawer();
            }
            
            // 4. Log lead to Google Sheets (if Web App URL is configured)
            const GOOGLE_SHEETS_WEB_APP_URL = "https://script.google.com/macros/s/AKfycbwxnIGuy3hoZ2x_YshMit-4RsPXFYBe28th4ZB_d8ITnDKQ3f8aJYWcBhFzo_iduML4qA/exec";
            if (GOOGLE_SHEETS_WEB_APP_URL) {
              fetch(GOOGLE_SHEETS_WEB_APP_URL, {
                method: "POST",
                mode: "no-cors",
                headers: {
                  "Content-Type": "application/json"
                },
                body: JSON.stringify({
                  name: nameVal,
                  email: emailVal,
                  phone: phoneVal,
                  discount_code: finalCode,
                  discount_percent: targetPercent,
                  timestamp: new Date().toISOString()
                })
              }).catch(err => console.warn("Google Sheets logging ignored/failed:", err));
            }
            
            // 5. Transform win overlay into code reveal card
            const winOverlay = document.getElementById("win-modal-overlay");
            const winCard = winOverlay ? winOverlay.querySelector(".win-card") : null;
            if (winCard) {
              winCard.innerHTML = `
                <div class="win-badge" style="background: #00e87b; color: #000;">CODE ACTIVATED</div>
                <h2 class="win-message" style="margin-bottom: 8px;">YOUR ${targetPercent}% DISCOUNT</h2>
                <p style="font-size: 9px; color: #666; font-family: var(--font-mono); margin-bottom: 20px; text-transform: uppercase; letter-spacing: 0.05em;">AUTO-APPLIED AT CHECKOUT • SINGLE USE • 24 HR EXPIRY</p>
                <div style="background: #0a0a0a; border: 1px dashed #333; padding: 18px 24px; text-align: center; margin-bottom: 16px;">
                  <div style="font-family: var(--font-mono); font-size: 22px; font-weight: 700; color: #ffffff; letter-spacing: 0.15em;" id="revealed-code">${finalCode}</div>
                </div>
                <button id="copy-code-btn" style="width: 100%; background: transparent; border: 1px solid #333; color: #fff; font-family: var(--font-mono); font-size: 10px; letter-spacing: 0.1em; padding: 12px; cursor: pointer; text-transform: uppercase; transition: all 0.3s ease; margin-bottom: 12px;">TAP TO COPY CODE</button>
                <a href="shop.html" style="display: block; width: 100%; background: #fff; color: #000; font-family: var(--font-mono); font-size: 10px; font-weight: 700; letter-spacing: 0.1em; padding: 12px; text-align: center; text-decoration: none; text-transform: uppercase; box-sizing: border-box;">SHOP NOW →</a>
              `;
              // Bind copy button
              const copyBtn = document.getElementById("copy-code-btn");
              if (copyBtn) {
                copyBtn.addEventListener("click", () => {
                  navigator.clipboard.writeText(finalCode).then(() => {
                    copyBtn.textContent = "✓ COPIED TO CLIPBOARD";
                    copyBtn.style.borderColor = "#00e87b";
                    copyBtn.style.color = "#00e87b";
                    setTimeout(() => {
                      copyBtn.textContent = "TAP TO COPY CODE";
                      copyBtn.style.borderColor = "#333";
                      copyBtn.style.color = "#fff";
                    }, 2500);
                  });
                });
              }
            }
          }

          // Static tier code (FNTROO10/20/30/50).
          //
          // The Vercel build minted a unique single-use code per win via
          // /api/get-discount, which needs a server-side Admin API secret. A
          // Shopify theme has no server to hold one, so the tier codes are
          // created once in admin with usage limits instead. This was already
          // the old code's fallback path whenever the function was unreachable.
          completeLead(targetCode);
        });
      }
    });
